import { filter, map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';

import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { LoadJobsiteAddress } from '../../../actions/jobsite-actions/jobsite.actions';
import { Injectable } from '@angular/core';
import { getJobsiteState, OrderBuilderState } from '../../../../../reducers';
import { IJobsiteState } from '../../../reducers/jobsite-reducer/jobsite.reducer';

@Injectable()
export class JobsiteLoadAddressCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .select(getJobsiteState)
      .pipe(
        take(1),
        map((state: IJobsiteState) => {
          return state.jobsites.find((jobsite: IShipmentLocation) => {
            return jobsite.shipmentLocationId === value;
          });
        }),
        filter(jobsite => !!jobsite),
      )
      .subscribe((jobsite: IShipmentLocation) =>
        this.store.dispatch(new LoadJobsiteAddress(jobsite.address.addressId)),
      );
  }
}
